<template>
  <div class="rate-shop-benchmark-row">
    <RateBenchmarks
      :benchmarks="benchmarks"
      :loading="rateShop.loading"
      class="flex-shrink-1"
    />
    <!-- keep freight allowance right aligned when no benchmarks are shown -->
    <div v-if="showFreightAllowance">&nbsp;</div>
    <div
      v-if="showFreightAllowance"
      class="freight-allowance-view-edit-wrapper"
    >
      <FreightAllowanceViewEdit
        v-model="freightAllowanceInternal"
        :disabled="!freightAllowanceEditable"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import type { PropType } from 'vue';
import { toRefs } from 'vue';

import { Loadable } from '@rygen/rygen-ui/model';

import { useFreightAllowance } from '@/composables';
import { FreightAllowance, RateQuote, RateShop } from '@/model';

import FreightAllowanceViewEdit from '@/components/rateShop/FreightAllowanceViewEdit.vue';
import RateBenchmarks from '@/components/rateShop/RateBenchmarks.vue';

const props = defineProps({
  benchmarks: {
    type: Array as PropType<RateQuote[]>,
    default: () => [],
  },
  rateShop: {
    type: Object as PropType<Loadable<RateShop>>,
    default: () => ({ loading: false }),
  },
  freightAllowance: {
    type: Object as PropType<FreightAllowance | undefined>,
    default: () => undefined,
  },
  showFreightAllowance: {
    type: Boolean,
    default: () => false,
  },
  freightAllowanceEditable: {
    type: Boolean,
    default: () => false,
  },
});
const {
  benchmarks,
  rateShop,
  freightAllowance,
  showFreightAllowance,
  freightAllowanceEditable,
} = toRefs(props);
const emit = defineEmits<{
  (
    event: 'update:freight-allowance',
    freightAllowance?: FreightAllowance,
  ): void;
}>();

const { freightAllowanceInternal } = useFreightAllowance(
  freightAllowance,
  emit,
);
</script>

<style>
.rate-shop-benchmark-row {
  display: flex;
  justify-content: space-between;
  align-items: start;
  gap: var(--sp-3);

  &:empty {
    display: none;
  }
}
</style>
